export enum StatusRelatorioEnum {
  EM_FILA = 1,
  PROCESSANDO = 2,
  FINALIZADO = 3,
  ERRO = 4,
  CANCELADO = 5,
}
